import { login, logout, refreshToken } from "@features/auth/api/authApi";
import { useAuthStore } from "@features/auth/store/authStore";
import { AuthResponse } from "@features/auth/types/authResponse";
import { LoginRequest } from "@features/auth/types/loginRequest";
import { ApiMessageResponse } from "@core/types/apiMessageResponse";
import ApiResponse from "@core/types/apiResponse";
import { clearClientSessionArtifacts } from "@features/auth/utils/clearClientSessionArtifacts";

export const loginAsync = async (request: LoginRequest): Promise<ApiResponse<AuthResponse>> => {
    const response = await login(request);
    if (response.isSuccess()) {
        useAuthStore.getState().setAccessToken(response.getData()!.token);
    }
    return response;
};

export const refreshTokenAsync = async (): Promise<ApiResponse<AuthResponse>> => {
    const response = await refreshToken();
    if (response.isSuccess()) {
        useAuthStore.getState().setAccessToken(response.getData()!.token);
    }
    return response;
};

/**
 * Logs the user out: calls the API to invalidate the server-side refresh token
 * (and expire its cookie), then always clears local auth state and session
 * caches regardless of the API outcome so the user is never left half-logged-out.
 */
export const logoutAsync = async (): Promise<ApiResponse<ApiMessageResponse>> => {
    try {
        return await logout();
    } finally {
        useAuthStore.getState().clearAccessToken();
        clearClientSessionArtifacts({ clearReturnUrl: true });
    }
};

